import { render, staticRenderFns } from "./SelectableChipDropdown.vue?vue&type=template&id=9f6ea118&scoped=true"
import script from "./SelectableChipDropdown.vue?vue&type=script&lang=js"
export * from "./SelectableChipDropdown.vue?vue&type=script&lang=js"
import style0 from "./SelectableChipDropdown.vue?vue&type=style&index=0&id=9f6ea118&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6ea118",
  null
  
)

export default component.exports